import { Box } from '@mui/material'

const NotFound = () => {
  return <Box>404 - page not found</Box>
}

export default NotFound
